import { icons } from 'src/assets/iconDef/icon.def';

export const crmMenuDef = [
    {
        name: 'Pricing',
        icon: 'fa fa-calendar',
        children: [
            {
                "name": "my_course",
                "resource": "my_course",
                "icon": "fa fa-superpowers",
                "url": "my_course",
                "auto_crud": true,
                "breadcrumb": "my_course"
            }
        ]
    }
]
